import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import Game1 from './Game1';
import Game2 from './Game2';
import reportWebVitals from './reportWebVitals'; // 確保引入這個模塊
import whirlpoolVideo from './whirlpool.mp4';

ReactDOM.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/game1" element={<Game1 />} />
      <Route path="/game2" element={<Game2 />} />
    </Routes>
  </Router>,
  document.getElementById('root')
);

// 使用 reportWebVitals
reportWebVitals(console.log);
